import { writable } from 'svelte/store';

export const modalsStore = writable({
  showCreateLink: false
});
